// removed by extract-text-webpack-plugin
module.exports = {"root":"_UySbs","placeholder":"_3He3c","arrowIcon":"_2ugah","wrapper":"_HrhoP","active":"_CfGkm","mobile":"_1pGpv","header":"_28GWq","inner":"_1TsNh","quota":"_8Buyy","billingCycleUnit":"_3na9F"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/TokenPack/components/TokenDropdown/TokenDropdown.scss
// module id = 1343
// module chunks = 3